// src/services/employeeService.js (client)
import api from './api'

/**
 * Servicio para gestionar operaciones CRUD de empleados
 */
export const employeeService = {
  async getEmployees(params = {}) {
    try {
      const queryParams = new URLSearchParams()
      if (params.orden) queryParams.append('orden', params.orden)
      if (params.dir) queryParams.append('dir', params.dir)
      if (params.limit) queryParams.append('limit', params.limit)
      if (params.offset) queryParams.append('offset', params.offset)
      if (params.rol) queryParams.append('rol', params.rol)
      if (typeof params.activo !== 'undefined') queryParams.append('activo', params.activo ? '1' : '0')

      const queryString = queryParams.toString()
      const url = `/empleados${queryString ? `?${queryString}` : ''}`

      const response = await api.get(url)
      return response.data
    } catch (error) {
      console.error('[ERROR Employee Service] Error getting employees:', error)
      throw error
    }
  },

  async getEmployee(id) {
    try {
      const response = await api.get(`/empleados/${id}`)
      return response.data
    } catch (error) {
      console.error('[ERROR Employee Service] Error getting employee:', error)
      throw error
    }
  },

  async createEmployee(employeeData) {
    try {
      const response = await api.post('/empleados', employeeData)
      return response.data
    } catch (error) {
      console.error('[ERROR Employee Service] Error creating employee:', error)
      throw error
    }
  },

  async updateEmployee(id, employeeData) {
    try {
      const response = await api.put(`/empleados/${id}`, employeeData)
      return response.data
    } catch (error) {
      console.error('[ERROR Employee Service] Error updating employee:', error)
      throw error
    }
  },

  async deleteEmployee(id) {
    try {
      const response = await api.delete(`/empleados/${id}`)
      return response.data
    } catch (error) {
      console.error('[ERROR Employee Service] Error deleting employee:', error)
      throw error
    }
  }
}

export default employeeService
